import { HttpBackend, HttpClient } from '@angular/common/http';
import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, UpdateAvailableEvent } from '@angular/service-worker';
import { isNullOrEmpty } from '../../../util/src/public-api';
import { NGXLogger } from 'ngx-logger';
import { interval, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateDetectionService {
  private versionSubject$ = new Subject<UpdateAvailableEvent>();
  versionSubject = this.versionSubject$.asObservable();
  versionTimestamp?: number;

  constructor(
    private appRef: ApplicationRef,
    private updates: SwUpdate,
    private httpBackend: HttpBackend,
    private logger: NGXLogger
  ) {
    if (this.isEnabled) {
      // // Allow the app to stabilize first, before starting
      // // polling for updates with `interval()`.
      // const appIsStable$ = appRef.isStable.pipe(first(isStable => {
      //   return isStable === true;
      // }));

      // const checkOnceAppIsStable$ = concat(appIsStable$, interval(60 * 1000));
      this.logger.debug(
        'AppUpdateDetectionService - constructor: Subscribe interval SwUpdate checkForUpdate'
      );
      interval(60 * 1000).subscribe(
        () => {
          updates.checkForUpdate().then(() => {
            this.logger.debug(
              'AppUpdateDetectionService - SwUpdate: checkForUpdate'
            );
            // timer(60 * 1000, 60 * 1000).subscribe(() => {
            new HttpClient(this.httpBackend)
              .get('ngsw.json?timestamp=' + new Date().getTime())
              .subscribe(
                (result: any) => {
                  this.logger.debug(
                    'AppUpdateDetectionService - timer: check version'
                  );
                  if (
                    !isNullOrEmpty(this.versionTimestamp) &&
                    result.timestamp !== this.versionTimestamp
                  ) {
                    this.logger.info(
                      'AppUpdateDetectionService - constructor - check timer: New version detected.'
                    );
                    this.versionSubject$.next();
                  }
                  this.versionTimestamp = result.timestamp;
                },
                (err) => {
                  this.logger.error('Failed to fetch version info.', err);
                }
              );
            // });
          });
        },
        (err) => {
          this.logger.error('Failed to check version updates.', err);
        }
      );
    }
  }

  get isEnabled(): boolean {
    return this.updates.isEnabled;
  }

  checkForUpdates(): void {
    this.updates.available.subscribe((event: any) => {
      this.logger.info(
        'AppUpdateDetectionService SwUpdate - available: New version detected.',
        event
      );
      this.versionTimestamp = (event.available.appData as any)?.timestamp;
      this.versionSubject$.next(event);
    });
  }

  loadNewAppVersion(): void {
    this.updates.activateUpdate().then(() => {
      window.location.reload();
    });
  }
}
